import React, { useState } from 'react';
import { WorkplaceMember } from '../../../../../graphql/graphql';
// @ts-ignore
import styles from './WorkplaceWorkerWorkplacesList.module.scss';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import WorkplaceWorkerWorkplacesEdit from './WorkplaceWorkerWorkplacesEdit';
import { useAppContext } from '../../../../../Services/AppContext';
import NetteApiClient from '../../../../../Services/NetteApiClient';
import useTranslation from '../../../../../Hooks/useTranslation';
import loading from '../../../../../Components/Loading';

interface Props {
	userId: string;
	data: WorkplaceMember[];
	showAllWorkplaces: boolean;
	onUpdate: () => void;
	onDeleteFromAllWorkplaces: () => void;
}

const WorkplaceWorkerWorkplacesList: React.FC<Props> = ({
	data,
	showAllWorkplaces,
	userId,
	onUpdate,
	onDeleteFromAllWorkplaces,
}) => {
	// @ts-ignore
	const { userData, onSelfEdit } = useAppContext();
	const [isEditMode, setIsEditMode] = useState(false);
	const { t } = useTranslation();

	const handleOnUpdate = () => {
		setIsEditMode(false);
		//EDITING SELF NETTE REFRESH
		if (userData.id === userId && onSelfEdit) {
			NetteApiClient.get(onSelfEdit);
		}
		onUpdate();
	};

	if (isEditMode) {
		return (
			<WorkplaceWorkerWorkplacesEdit
				userId={userId}
				onUpdate={handleOnUpdate}
				showAllWorkplaces={showAllWorkplaces}
				data={data}
				onDeleteFromAllWorkplaces={onDeleteFromAllWorkplaces}
			/>
		);
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.title}>
				{t('component.doctorDetailComponent.workplacesToWhichTheWorkerIsAdded')}
				:
			</div>
			<div className={styles.workplacesWrapper}>
				{data?.map(item => (
					<div className={styles.workplace} key={item.id}>
						<div>{item?.workplace?.name}</div>
						<div>
							{item?.workplaceMemberRoles?.map((role, index, arr) => (
								<span key={index}>
									{role?.role?.name}
									{arr.length > index + 1 ? ', ' : ''}
								</span>
							))}
						</div>
					</div>
				))}
			</div>
			<Button
				theme={Theme.GREEN}
				title='component.workplaceAndWorkers.editWorkplace'
				className={styles.button}
				onClick={() => setIsEditMode(true)}
			/>
		</div>
	);
};

export default WorkplaceWorkerWorkplacesList;
